import React from "react";

// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconMail,
    IconCalendar,
    IconNfc,
    IconBuildingStore,
} from "@tabler/icons";
import { getDecryptDataFromLocal } from "../../utils/encrypt";

// constant
const icons = {
    IconUserCheck: IconUserCheck,
    IconBasket: IconBasket,
    IconMessages: IconMessages,
    IconMail: IconMail,
    IconCalendar: IconCalendar,
    IconNfc: IconNfc,
    IconBuildingStore: IconBuildingStore,
};

//-----------------------|| Customer MENU ITEMS ||-----------------------//
let item = []
let role = getDecryptDataFromLocal('setRole')
let phoneNumber = getDecryptDataFromLocal('phoneNumber')

// Only userType 1, 2, 3, 17 and phone 9873804039 can access finance download & product wise report
const financeReportAllowedTypes = [1, 2, 3, 4, 17]
const financeReportAllowedPhone = '9873804039'
const canAccessFinanceReports = financeReportAllowedTypes.includes(Number(role)) || phoneNumber == financeReportAllowedPhone

if (canAccessFinanceReports) {
    item = [
        {
            id: "Orders Reports",
            title: <FormattedMessage id="Orders Reports" />,
            type: "item",
            url: "/financialreport/downloadorders",
        },
        {
            id: "Product Wise Reports",
            title: <FormattedMessage id="Product Wise Report" />,
            type: "item",
            url: "/financialreport/productWiseReport",
        },
        {
            id: "New Product Wise Reports",
            title: <FormattedMessage id="New Product Wise Report" />,
            type: "item",
            url: "/financialreport/newproductWiseReport",
        },
        {
            id: "Product Wise Reports V2",
            title: <FormattedMessage id="Product Wise Report V2" />,
            type: "item",
            url: "/financialreport/productWiseReportV2",
        },
        {
            id: "Brand Wise Report",
            title: <FormattedMessage id="Brand Wise Report" />,
            type: "item",
            url: "/financialreport/brandWiseReport",
        },
        {
            id: "ReconcileReport",
            title: <FormattedMessage id="Cash Reconcile Report" />,
            type: "item",
            url: "/financialreport/ReconcileReport",
        },
        {
            id: "cash received",
            title: <FormattedMessage id="Cash Received: InTransit" />,
            type: "item",
            url: "/financialreport/cash-intransit",
        },
        {
            id: "Order Details By Cashback Created",
            title: <FormattedMessage id="Order Details: By Cashback Created" />,
            type: "item",
            url: "/financialreport/order-by-cashback-created",
        },
        {
            id: "Return Pickup Report",
            title: <FormattedMessage id="Return Pickup Report" />,
            type: "item",
            url: "/financialreport/return-pickup-report",
        },
        {
            id: "Credit Notes",
            title: <FormattedMessage id="Credit Notes (Zoho)" />,
            type: "item",
            url: "/financialreport/credit-notes",
        }
    ]
}


export const FinancialReports = {
    id: "Financial",
    title: <FormattedMessage id="Financial Report" />,
    type: "group",
    children: [
        {
            id: "Financial Report",
            title: <FormattedMessage id="Financial Report" />,
            type: "collapse",
            icon: icons["IconBuildingStore"],
            children: item
        },
    ],
};
